import React, {Component} from 'react';
import { Icon, Menu, Dropdown, Modal,Drawer, Button,Radio,message,Badge } from 'antd';
import createHistory from 'history/createHashHistory';
import { connect } from "react-redux"//联系store的组件
import evn from "./../../../actions/index"//action的所有事件

import EventSet from "./../../../assets/PubJs/hcPub"

import Event from "./../../../assets/PubJs/hcPub"
import CompanyModal from "./../Business/CompanyCenter/CompanyModal/index"//组件携带参数“0”或者“1”，0为有切换用户，1无切换用户
import $ from "jquery"
import { Hcurl,BackoffUrl } from "./../../../constants/index"//获取公共路径
const history = createHistory();


//切换主体抽屉
var _mainDawer = null
class MainDawer extends Component{
    state={
        visible:false,
        listData:[],
    }
    componentDidMount(){
        _mainDawer =this
    }
    onClose = ()=>{
        this.setState({
            visible:false
        })
    }
    //切换选择
    changeSelect=(item,index)=> {

         var newdata = this.state.listData
         newdata.forEach((si,ind) => {
          si.isSelected = ind === index;
        });
 
        this.setState({
            listData:newdata
        })

      }
      addCompany = () => {
          var newArr  = this.state.listData.filter((item)=>{
              return item.isSelected
          })
          console.log('43',newArr)
        //   return false
        let setData = {
            UserCode: Event.getUserInfo().CU_Code,
            CompanyCode:newArr[0].Com_Code,
            Type: "0",
        };
        $.ajax({
            url: Hcurl + "/CompanyCore/ChangeValidCompany",
            type: "post",
            data: {
                UserCode:EventSet.getUserInfo().CU_Code,
                CompanyCode:newArr[0].Com_Code,
            },
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                if(res =='1'){
                    $.ajax({
                        url: Hcurl + "/CompanyCore/ChangeCompany",
                        type: "post",
                        data: setData,
                        async: false,
                        headers: {
                            "token": EventSet.getUserInfo()['token']
                        },
                        success: function (res) {
                            console.log(res, 'res');
                            if (res.split("|")[0] == "false") {
                                message.error(res.split("|")[1]);
                         
                            } else {
                                message.success('提交成功',0.5);
                                let userInfo = JSON.parse(localStorage.userInfo);
                                userInfo.xxhjcompanycode = res.split("|")[1];
                                userInfo.XXHJCom_Name = res.split("|")[2];
                                userInfo.UCR_IsAdmin = res.split("|")[3];
                                localStorage.setItem("userInfo", JSON.stringify(userInfo));
                                console.log(JSON.parse(localStorage.getItem('userInfo')), '213');
                                // window.location.reload()
                                _mainDawer.setState({
                                    visible:false
                                })
                                history.push({ pathname: '/Content/Home' })
                                setTimeout(() => {
                                    window.location.reload()
                                }, 500);
                                
                            }
                        },
                        error: function (data, err) {
                           
                            if (!JSON.parse(data.responseText).success && data.status === 403) {
                                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                            } else {
                                message.error(err)
                            }
                        }
                    })
                }else{
                    message.error('无法选择，未绑定/加入此主体。');
                }
            }
        })
        
    }
    render(){
        return (
            <div>
                <Drawer
          title="切换主体"
          placement="right"
          onClose={this.onClose}
          visible={this.state.visible}
          width={540}
        >
            <div style={{paddingBottom:'50px'}}>
        {this.state.listData.map((item,index)=>{
            return (<div className="companyBox" style={{position:'relative'}} key={index} onClick={()=>this.changeSelect(item,index)} >
                    <div className="leftRadio">
                        <Radio key={item.Com_CreditCode} name={'aa'} checked={item.isSelected}></Radio>
                    </div>
                    <div className="rightName" >
                        <div className="companyName" title={item.Com_Name}>{item.Com_Name}</div>
                        <div className="companyText">统一社会信用代码：{item.Com_CreditCode}</div>
                       {item.unDealCount>0?<div style={{position:'absolute',top:'18px',right:'20px',color:'#fa541c'}}>有待办项</div>:''} 
                    </div>
            </div>) 
        })}
          </div>
          <div style={{position:"absolute",right:'0',bottom:'0',height:'50px',width:'100%',padding:'0 24px',lineHeight:'50px',borderTop:'1px solid #f2f2f2',background:'#fff'}}>
              <span>请选择需要切换的主体</span>
              <Button onClick={this.addCompany} style={{float:'right',marginTop:'10px'}} type="primary">提交</Button>
              <Button onClick={this.onClose} style={{float:'right',marginRight:'8px',marginTop:'10px'}}>取消</Button>
              
          </div>
        </Drawer>
        </div>
        )
    }
    
}

var _App = null
class App extends Component {
    state = {
        userName: "",
        visible: false,
        info2:"",
        listData:[],
        num:'',
    }

    componentDidMount() {
        _App = this
        this.setState({
            userName: JSON.parse(localStorage.getItem("userInfo")).userName
        })
        this.getUser()
        _App.getCompany()
        $.ajax({
            url: Hcurl + "/HomePage/GetDepartmentUserWorkItemInfo?UserCode=" + EventSet.getUserInfo().CU_Code+"&comCode=" + EventSet.getUserInfo().xxhjcompanycode,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            async: false,
            success: function (res) {
                _App.setState({
                    num:res[0]
                })
                
            },
            error: function () {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
        _App.CheckChangeCompany()
    }

    //返回首页
    goHome() {
        history.push({ pathname: '/Content/Home' })
          let key = []
            this.props.dispatch(evn.changeNavSelectkey(key));
            this.props.dispatch(evn.changeNavOpenkey(key))
    }

    //个人设置
    personalSetting = () => {
        history.push({ pathname: '/Content/UserInfo', })
    }

    getUser() {
        let _this = this;
        $.ajax({
            url: Hcurl + "/user/GetUserInfo",
            type: "post",
            data: {
                CU_Code: JSON.parse(localStorage.getItem("userInfo")).CU_Code
            },
            headers: {
                token: JSON.parse(localStorage.getItem("userInfo")).token
            },
            async: false,
            success: function (res) {
                //密码和手机号
                _this.setState({
                    info2: JSON.parse(res)
                })
            },
            error: function (res) {
                history.push({ pathname: '/Login/LoginMain/LoginEntry', })
            }
        })
    }
    //注销
    Cancellation = () => {
        this.setState({
            visible: true,
        });
    }
    //注销弹窗确定
    ModalQuery = () => {
        this.setState({
            visible: true,
        }, () => {
            history.push({ pathname: '/Login/LoginMain/LoginEntry' })
            let key = []
            this.props.dispatch(evn.changeNavSelectkey(key));
            this.props.dispatch(evn.changeNavOpenkey(key))
            setTimeout(function () { localStorage.removeItem("userInfo");},100)
            });
    }
    hideModal = () => {
        this.setState({
            visible: false,
        });
    }
    changeMain=()=>{
        _mainDawer.setState({
            visible:true
        })
       
        _App.getCompany()
    }
    showModal() {
        this.props.dispatch(evn.showModal())
    }
    toSubject(){
        history.push({ pathname: '/Content/Business/CompanyList', })
    }
    CheckChangeCompany(){
        $.ajax({
            url: Hcurl + "/CompanyCore/CheckChangeCompany",
            type: "post",
            data: {
                UserCode: JSON.parse(localStorage.getItem("userInfo")).CU_Code,
                CompanyCode:JSON.parse(localStorage.getItem("userInfo")).xxhjcompanycode
            },
            headers: {
                token: JSON.parse(localStorage.getItem("userInfo")).token
            },
            async: false,
            success: function (res) {
                console.log(JSON.parse(res))
               
                var data = JSON.parse(res)
                if(data.length>0){
                    let userInfo = JSON.parse(localStorage.userInfo);
                    userInfo.xxhjcompanycode = data[0].xxhjcompanycode;
                    userInfo.XXHJCom_Name = data[0].Com_Name;
                    localStorage.setItem("userInfo", JSON.stringify(userInfo));
                  
                }else{
                    let userInfo = JSON.parse(localStorage.userInfo);
                    userInfo.xxhjcompanycode = '';
                    userInfo.XXHJCom_Name ='';
                    localStorage.setItem("userInfo", JSON.stringify(userInfo));
                }
                
            },
            error: function () {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }
    getCompany(){
        $.ajax({
            url: Hcurl + "/CompanyCore/GetSelectCompany",
            type: "post",
            data: {
              UserCode: JSON.parse(localStorage.getItem("userInfo")).CU_Code,
              CompanyCode :JSON.parse(localStorage.getItem("userInfo")).xxhjcompanycode
            },
            headers: {
              "token": JSON.parse(localStorage.getItem("userInfo")).token
            },
            success: function (res) {
                    var res =JSON.parse(res)
                    console.log('162',res)
                
                    res.map((item) => {
                      if (item.Com_Name == JSON.parse(localStorage.getItem("userInfo")).XXHJCom_Name) {
                        item.isSelected = true;
                      }
                    });
                    console.log('167',res)
                  
             _mainDawer.setState({
                listData:res
             })
             _App.setState({
                listData:res
             })
      
            },
            error: function () {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
          })
    }
    render() {

        const menu = (
            <Menu>
                <Menu.Item>
                    <a rel="noopener noreferrer" onClick={this.personalSetting}>个人设置</a>
                </Menu.Item>
                {/*<Menu.Item>
                    <a rel="noopener noreferrer" href="">密码修改</a>
                </Menu.Item>*/}
                <Menu.Item>
                    <a rel="noopener noreferrer" onClick={this.Cancellation}>注销</a>
                </Menu.Item>
            </Menu>
        );
        const help = (
            <Menu>
                <Menu.Item>
                    <a rel="noopener noreferrer" href="">和解平台使用说明</a>
                </Menu.Item>
                <Menu.Item>
                    <a rel="noopener noreferrer" href="">经营者信用评级积分使用说明</a>
                </Menu.Item>
            </Menu>
        );
        const companyMain = (
            <Menu>
                <Menu.Item>
                    <a onClick={this.changeMain} >切换主体</a>
                </Menu.Item>
                <Menu.Item>
                    <a onClick={this.showModal.bind(this)}>绑定/加入主体</a>
                </Menu.Item>
                <Menu.Item>
                    <a onClick={this.toSubject}>主体管理</a>
                </Menu.Item>
            </Menu>
        )
        const companyMainOther = (
            <Menu>
                <Menu.Item>
                    <a onClick={this.showModal.bind(this)}>绑定/加入主体</a>
                </Menu.Item>
                <Menu.Item>
                    <a onClick={this.toSubject}>主体管理</a>
                </Menu.Item>
            </Menu>
        )
        return (
            <div>
                {(JSON.parse(localStorage.getItem("userInfo")).XXHJCom_Name!=''&&JSON.parse(localStorage.getItem("userInfo")).XXHJCom_Name!=null)?<Dropdown overlay={this.state.listData.length>1?companyMain:companyMainOther}>
                 {this.state.num.hasOtherUnDealCount>0?  <Badge dot><span  className="ant-dropdown-link"  ><Icon type="home" style={{fontSize: 16, marginRight: 4}}/>{JSON.parse(localStorage.getItem("userInfo")).XXHJCom_Name.length>10?JSON.parse(localStorage.getItem("userInfo")).XXHJCom_Name.substring(0,10)+'...':JSON.parse(localStorage.getItem("userInfo")).XXHJCom_Name}</span></Badge>:<span  className="ant-dropdown-link"  ><Icon type="home" style={{fontSize: 16, marginRight: 4}}/>{JSON.parse(localStorage.getItem("userInfo")).XXHJCom_Name.length>10?JSON.parse(localStorage.getItem("userInfo")).XXHJCom_Name.substring(0,10)+'...':JSON.parse(localStorage.getItem("userInfo")).XXHJCom_Name}</span>}
                </Dropdown>: <span  onClick={this.showModal.bind(this)} className="ant-dropdown-link"><Icon type="home" style={{fontSize: 16, marginRight: 4}}/>无关联主体，立即绑定/加入</span>}
                
                <span onClick={this.goHome.bind(this)}>
                    首页
                </span>
               {/* JSON.parse(localStorage.getItem("userInfo")).url */}
                <span onClick={() => window.open('https://www.jsca315.org.cn/jiangsu/index.html', '_blank') }>返回官网</span>
                <Dropdown overlay={menu}>
                    <span className="ant-dropdown-link">{this.state.info2.userName||this.state.info2.loginName} <Icon type="down"/></span>
                </Dropdown>
                {/*
                 *  <Dropdown size="small" overlay={help}>
                    <span className="ant-dropdown-link">帮助 <Icon type="down"/></span>
                </Dropdown>
                 */}
                <Modal
                    title="注销"
                    visible={this.state.visible}
                    onOk={this.ModalQuery}
                    onCancel={this.hideModal}
                    okText="确认"
                    cancelText="取消"
                >
                    <p>确定注销本次登录吗?</p>
                </Modal>
                <MainDawer/>
                <CompanyModal type={"0"} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        openkey: state.NavKey.openkey,
        selectkey: state.NavKey.selectkey,
    }
};
export default connect(mapStateToProps)(App)


// WEBPACK FOOTER //
// ./src/components/Content/Wrap/HelpBar.js